export default __webpack_public_path__ + "static/media/img_area_25.a54a26d8.svg";